// B-side header dropdown + floating bottom nav + A-side scroll flip + newsletter/contact success UX + music platform picker + product-card interactions.
// Ported from the prototype's site.js; cart logic lives in cart.js (Ajax Cart API).
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-menu-toggle]');
  const nav = document.querySelector('.mobile-nav');
  if (btn && nav) { nav.classList.toggle('open'); return; }
  if (nav && nav.classList.contains('open') && !e.target.closest('.mobile-nav') && !e.target.closest('[data-menu-toggle]')) {
    nav.classList.remove('open');
  }
});

// ---- Music page: platform picker popup (shared by "Stream now" + every track row) ----
document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-platform-modal-open]');
  if (opener) {
    const modal = document.querySelector('[data-platform-modal]');
    if (!modal) return;
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    return;
  }
  if (e.target.closest('[data-platform-modal-close]')) {
    const modal = document.querySelector('[data-platform-modal]');
    if (!modal) return;
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
});
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  const modal = document.querySelector('.platform-modal.open');
  if (!modal) return;
  modal.classList.remove('open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
});

// ---- B-side header: hamburger dropdown menu ----
(function () {
  const btn = document.querySelector('[data-header-menu-toggle]');
  const menu = document.querySelector('[data-header-menu]');
  if (!btn || !menu) return;
  const setOpen = (open) => { menu.hidden = !open; btn.setAttribute('aria-expanded', String(open)); };
  btn.addEventListener('click', (e) => { e.stopPropagation(); setOpen(menu.hidden); });
  document.addEventListener('click', (e) => {
    if (!menu.hidden && !menu.contains(e.target) && !btn.contains(e.target)) setOpen(false);
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !menu.hidden) setOpen(false); });

  // Desktop hover (2026-11-02, per Chase — replaces the CSS :hover chain + invisible bridge, which
  // dropped the menu whenever the cursor left the icon on its way down). Hovering the hamburger
  // opens the menu right under the logo row (wherever that row currently is — it slides away on
  // collection pages); leaving the icon or the menu only closes it after a short grace period, so
  // the cursor can travel from the icon to the menu. Re-entering either one cancels the close.
  const hoverMQ = window.matchMedia('(min-width: 761px) and (hover: hover)');
  const band = btn.closest('.header-nav-band');
  let closeTimer = null;
  const place = () => {
    if (!band) return;
    menu.style.top = Math.max(0, Math.round(band.getBoundingClientRect().bottom) + 4) + 'px';
  };
  const openHover = () => {
    if (!hoverMQ.matches) return;
    clearTimeout(closeTimer);
    place();
    setOpen(true);
  };
  const closeSoon = () => {
    if (!hoverMQ.matches) return;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => setOpen(false), 450);
  };
  btn.addEventListener('mouseenter', openHover);
  btn.addEventListener('mouseleave', closeSoon);
  menu.addEventListener('mouseenter', () => clearTimeout(closeTimer));
  menu.addEventListener('mouseleave', closeSoon);
  btn.addEventListener('click', place);
})();

// ---- Header dropdown: "Studio Collection" branch toggle (reveals Art/Clothing nested underneath) ----
(function () {
  const toggle = document.querySelector('[data-menu-branch-toggle]');
  const branch = document.querySelector('[data-menu-branch]');
  if (!toggle || !branch) return;
  toggle.addEventListener('click', (e) => {
    e.stopPropagation();
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    branch.hidden = open;
  });
})();

// ---- Floating bottom nav ----
(function () {
  const root = document.querySelector('[data-bottom-nav-tabs]');
  if (!root) return;
  const TABS = JSON.parse(root.textContent);
  const ICONS = {
    home: '<path d="M3 9.5 12 3l9 6.5V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z"/>',
    music: '<path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>',
    contact: '<rect x="2" y="4" width="20" height="16" rx="2"/><path d="M22 7l-10 6L2 7"/>',
    exhibitions: '<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>',
    shop: '<path d="M3 9l1-5h16l1 5"/><path d="M3 9a2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0"/><path d="M5 9v10h14V9"/><path d="M9 21v-6h6v6"/>'
  };
  // Tabs whose icon is a full self-contained SVG (own viewBox, fill-based)
  // rather than a stroke path drawn into the shared 24x24 wrapper. The home
  // tab uses the ONEANDONLY "oao" mark (fill:currentColor so it takes the
  // tab's active/inactive colour); sized by .bn-oao in theme.css. The
  // viewBox is widened past the source file's "0 0 892 334" (which clipped
  // the mark ~30px on the right / ~24px on top) so nothing gets cut off.
  const FULL_SVG = {
    home: '<svg class="bn-oao" viewBox="-26 -40 965 393" aria-hidden="true" style="fill-rule:evenodd;clip-rule:evenodd;overflow:visible;"><g transform="matrix(1,0,0,1,-18612.402258,-4940.049383)"><g transform="matrix(1,0,0,1,12834.077166,4225.777778)"><g transform="matrix(0.33012,0,-0,0.33012,4740.247169,-643.704016)"><path d="M3763.66,5034.65C3763.66,5034.65 3727.411,5036.215 3709.479,5035.932C3682.657,5035.508 3647.495,5033.759 3607.729,5028.983C3516.359,5018.007 3400.688,4991.044 3306.055,4927.418C3155.406,4826.132 3112.704,4668.236 3167.291,4530.442C3250.803,4319.631 3551.58,4146.461 3815.35,4146.189C3983.672,4146.019 4113.21,4196.162 4202.345,4276.122C4304.279,4177.673 4472.046,4112.224 4612.703,4113.607C4801.643,4115.462 4897.885,4175.616 4946.152,4267.139C5240.478,4040.266 5702.906,4154.197 5818.756,4454.701C5940.65,4770.881 5597.62,5035.137 5282.531,5035.472C5161.335,5035.604 5063.457,5012.318 4987.031,4972.135C4825.157,5134.517 4569.839,5033.982 4531.03,4827.966C4474.427,4832.329 4412.567,4832.686 4362.648,4831.939C4323.919,4886.566 4274.648,4944.645 4219.467,5000.557C4157.474,5063.379 4075.694,5130.552 3960.075,5124.575C3914.582,5122.223 3875.841,5109.16 3844.997,5093.595C3822.609,5082.297 3804.381,5069.68 3790.755,5058.886C3776.831,5047.856 3763.66,5034.65 3763.66,5034.65Z" style="fill:currentColor;"></path></g></g></g></svg>'
  };
  const path = location.pathname.replace(/\/$/, '');
  const nav = document.createElement('nav');
  nav.className = 'bottom-nav';
  nav.setAttribute('aria-label', 'Primary');
  const inner = document.createElement('div');
  inner.className = 'bottom-nav-inner';
  const pill = document.createElement('div');
  pill.className = 'bn-pill';
  inner.appendChild(pill);

  TABS.forEach(t => {
    const a = document.createElement('a');
    const isActive = t.active === true || path === t.href.replace(/\/$/, '') || (t.href === '/' && path === '');
    a.className = 'bn-tab' + (isActive ? ' active' : '');
    a.href = t.href;
    a.dataset.tabId = t.id;
    a.setAttribute('aria-label', t.label);
    if (isActive) a.setAttribute('aria-current', 'page');
    const iconSvg = FULL_SVG[t.id] || '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">' + (ICONS[t.id] || '') + '</svg>';
    a.innerHTML = iconSvg + '<span class="bn-label">' + t.label + '</span>';
    inner.appendChild(a);
  });
  nav.appendChild(inner);
  document.body.appendChild(nav);

  function positionPill() {
    const active = inner.querySelector('.bn-tab.active');
    if (!active) return;
    const c = inner.getBoundingClientRect();
    const b = active.getBoundingClientRect();
    pill.style.left = (b.left - c.left) + 'px';
    pill.style.width = b.width + 'px';
    pill.classList.add('ready');
  }
  requestAnimationFrame(() => requestAnimationFrame(positionPill));
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(positionPill);
  window.addEventListener('resize', positionPill);
})();

// ---- Music-side (homepage) header: dark ink while it floats over the
// light-topped hero photo, then flip to a slim light-on-dark bar once the
// hero has scrolled out of view and the near-black page is behind it. ----
(function () {
  const header = document.querySelector('.header-float--music');
  if (!header) return;
  const hero = document.querySelector('.hero-full');
  let ticking = false;
  function update() {
    const past = hero
      ? hero.getBoundingClientRect().bottom <= 64
      : window.scrollY > window.innerHeight * 0.7;
    header.classList.toggle('is-scrolled', past);
    ticking = false;
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }
  update();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
})();

// ---- Generic product lightbox opener (home + collection cards use [data-lightbox-trigger]) ----
(function () {
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-lightbox-open]');
    if (!trigger) return;
    const targetSel = trigger.getAttribute('data-lightbox-open');
    const lb = document.querySelector(targetSel);
    if (!lb) return;
    lb.classList.add('open');
    lb.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  });
  document.querySelectorAll('.lightbox').forEach((lb) => {
    lb.addEventListener('click', (e) => {
      if (e.target.closest('[data-close]') || e.target === lb) {
        lb.classList.remove('open');
        lb.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.lightbox.open').forEach((lb) => {
      lb.classList.remove('open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
  });
})();

// ---- Product cards: color-chip syncing helper — shared by both the
// chip-click handler and the arrow-nav handler below so selecting a color
// either way always keeps the photo, the active chip, the price, and the
// variant that Add to Cart will actually add all pointing at the same
// color. ----
function syncCardToColor(card, color) {
  if (!card || !color) return;
  const chip = card.querySelector('.card-size[data-color="' + CSS.escape(color) + '"]');
  if (!chip) return;
  const group = chip.closest('.card-sizes');
  if (group) group.querySelectorAll('.card-size').forEach((b) => b.classList.remove('active'));
  chip.classList.add('active');
  const price = chip.getAttribute('data-price');
  const variantId = chip.getAttribute('data-variant-id');
  const priceEl = card.querySelector('.card-row .price');
  if (priceEl && price) priceEl.textContent = price;
  const addBtn = card.querySelector('[data-add-to-cart]');
  if (addBtn && variantId) addBtn.setAttribute('data-variant-id', variantId);
  const media = card.querySelector('.card-media');
  const imgs = media && media.querySelectorAll('.card-img[data-card-color]');
  if (imgs && imgs.length) {
    imgs.forEach((img) => {
      img.classList.toggle('active', img.getAttribute('data-card-color') === color);
    });
  }
}

// ---- Product cards: size/color-chip selection syncs price + add-to-cart
// variant + (for color-variant products) the visible photo. ----
document.addEventListener('click', (e) => {
  const chip = e.target.closest('.card-size');
  if (!chip || chip.disabled) return;
  const card = chip.closest('.card');
  const color = chip.getAttribute('data-color');
  if (card && color && card.querySelector('.card-img[data-card-color]')) {
    syncCardToColor(card, color);
    return;
  }
  // Non-color products (plain size chips): original behavior, no photo swap.
  const group = chip.closest('.card-sizes');
  if (!group) return;
  group.querySelectorAll('.card-size').forEach((b) => b.classList.remove('active'));
  chip.classList.add('active');
  const price = chip.getAttribute('data-price');
  const variantId = chip.getAttribute('data-variant-id');
  const priceEl = card && card.querySelector('.card-row .price');
  if (priceEl && price) priceEl.textContent = price;
  const addBtn = card && card.querySelector('[data-add-to-cart]');
  if (addBtn && variantId) addBtn.setAttribute('data-variant-id', variantId);
});

// ---- Product cards: click-and-drag to scroll the size-chip row when it overflows
// (native overflow-x only responds to touch/trackpad swipe, not a mouse drag) ----
(function () {
  let dragEl = null, startX = 0, startScroll = 0, moved = false;
  document.addEventListener('mousedown', (e) => {
    const el = e.target.closest('.card-sizes');
    if (!el) return;
    dragEl = el;
    startX = e.pageX;
    startScroll = el.scrollLeft;
    moved = false;
  });
  document.addEventListener('mousemove', (e) => {
    if (!dragEl) return;
    const walk = e.pageX - startX;
    if (Math.abs(walk) > 4) {
      moved = true;
      dragEl.classList.add('dragging');
      dragEl.scrollLeft = startScroll - walk;
    }
  });
  document.addEventListener('mouseup', () => {
    if (dragEl) dragEl.classList.remove('dragging');
    dragEl = null;
  });
  // Capture-phase: swallow the click that follows a drag so it doesn't also
  // select whichever size chip the pointer happened to land on.
  document.addEventListener('click', (e) => {
    if (moved && e.target.closest('.card-sizes')) {
      e.stopPropagation();
      moved = false;
    }
  }, true);
})();

// ---- Product cards: image prev/next arrows cycle through product photos.
// For color-variant products each .card-img carries data-card-color (see
// product-card.liquid), so landing on a different photo also syncs the
// matching color chip / price / add-to-cart variant via syncCardToColor —
// otherwise the arrows could show "Red" while Add to Cart still adds
// whatever color chip was last clicked. ----
document.addEventListener('click', (e) => {
  const navBtn = e.target.closest('.card-nav');
  if (!navBtn) return;
  e.preventDefault();
  const media = navBtn.closest('.card-media');
  if (!media) return;
  const imgs = Array.prototype.slice.call(media.querySelectorAll('.card-img'));
  if (imgs.length < 2) return;
  let idx = imgs.findIndex((img) => img.classList.contains('active'));
  if (idx === -1) idx = 0;
  const dir = navBtn.classList.contains('card-nav-prev') ? -1 : 1;
  const nextIdx = ((idx + dir) % imgs.length + imgs.length) % imgs.length;
  imgs[idx].classList.remove('active');
  imgs[nextIdx].classList.add('active');

  const color = imgs[nextIdx].getAttribute('data-card-color');
  if (color) {
    const card = media.closest('.card');
    syncCardToColor(card, color);
  }
});

// ---- Shop page: category filter ----
document.querySelectorAll('.filter').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.filter').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const f = btn.dataset.filter;
    document.querySelectorAll('[data-catalog] .group-label, [data-catalog] .grid').forEach(el => {
      const groups = (el.dataset.group || '').split(' ');
      el.classList.toggle('hidden', !(f === 'all' || groups.includes(f)));
    });
  });
});

// ---- Newsletter (Shopify native customer signup, no external endpoint) ----
document.addEventListener('submit', (e) => {
  if (!e.target.matches('[data-newsletter-form]')) return;
  // Shopify's /contact#newsletter form posts natively; we only show the inline note
  // after a slight delay if JS is enabled (page will redirect back with ?customer_posted=true
  // handled by the section reading location.search on load — see newsletter.liquid).
});
(function () {
  const params = new URLSearchParams(location.search);
  if (params.get('customer_posted') !== 'true') return;

  // Show the success note
  const note = document.querySelector('[data-form-note]');
  if (note) { note.textContent = note.getAttribute('data-success-text') || 'You’re on the list.'; note.classList.add('is-visible'); }

  // Scroll the form into view (wait for the hero image so the position is right)
  const target = document.getElementById('newsletter-form') || note;
  const go = () => target && target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });

  // Tell the "Leads & Streaming" custom pixel the signup succeeded (it fires Lead)
  if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
    Shopify.analytics.publish('newsletter_signup', { page_path: location.pathname });
  }

  // Remove ?customer_posted=true so a refresh doesn't show the note or count Lead again
  params.delete('customer_posted');
  const qs = params.toString();
  history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
})();

// ---- Scroll pill: tiny bottom-right progress pill replacing the page scrollbar (styles in theme.css) ----
(function () {
  const pill = document.createElement('div');
  pill.className = 'scroll-pill';
  pill.setAttribute('aria-hidden', 'true');
  pill.innerHTML = '<span class="scroll-pill-fill"></span>';
  document.body.appendChild(pill);
  const fill = pill.firstChild;
  let ticking = false;
  const update = () => {
    ticking = false;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    pill.hidden = max <= 4;
    if (max > 4) fill.style.transform = 'scaleY(' + Math.min(Math.max(window.scrollY / max, 0), 1) + ')';
  };
  const queue = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  window.addEventListener('load', queue);
  if (window.ResizeObserver) new ResizeObserver(queue).observe(document.body);
  update();
})();
